import { useEffect, useState } from 'react';
import { useSalesConfig } from '../../../../api/hooks/sales/useSalesConfig';
import { Button } from '../../../common/button/Button';
import { Input } from '../../../common/input/Input';
import './sales-settings-panel.scss';

export const SalesSettingsPanel = () => {
  const { config, isLoading, update, isUpdating } = useSalesConfig();
  const [managerEmail, setManagerEmail] = useState('');
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    if (config?.managerEmail != null) {
      setManagerEmail(config.managerEmail);
    }
  }, [config]);

  const handleSave = (e) => {
    e.preventDefault();
    update({ managerEmail }, {
      onSuccess: () => {
        setSaved(true);
        setTimeout(() => setSaved(false), 2500);
      }
    });
  };

  if (isLoading) return <p className="sales-settings-panel__loading">Loading...</p>;

  return (
    <form className="sales-settings-panel" onSubmit={handleSave}>

      <div className="sales-config-card">
        <div className="sales-config-card__header">
          <h3>Agreement Notifications</h3>
        </div>
        <div className="sales-config-card__body">
          <p className="sales-settings-panel__description">
            When a consultant signs their agreement, a copy will automatically be emailed to this address.
          </p>
          <div className="sales-config-card__field">
            <Input
              label="Manager Email"
              type="email"
              name="managerEmail"
              value={managerEmail}
              onChange={({ value }) => setManagerEmail(value)}
              placeholder="e.g. manager@instant-meals.co.za"
            />
          </div>
        </div>
        <div className="sales-config-card__footer">
          <Button type="submit" loading={isUpdating}>Save</Button>
          {saved && <span className="sales-settings-panel__saved">Saved</span>}
        </div>
      </div>

    </form>
  );
};
